import { useEffect, useRef, useState, useMemo, useImperativeHandle, forwardRef } from "react";
import { Input, Select, ConfigProvider, Flex, Row, Col } from "antd";
import { TablePaginationConfig, TableProps } from "antd/es/table";
import { SorterResult } from "antd/es/table/interface";
import dayjs from "dayjs";
import { Value } from "sass";
const { TextArea } = Input;

const { Option } = Select;

 const AddNote = forwardRef(({ reasons, hideReasons }, ref) => {
    const [noteText, setNoteText] = useState('');
    const [noteReason, setNoteReason] = useState<any | null>(null);
    useImperativeHandle(ref, () => ({
        noteText,
        noteReason
    }));
    return (
        <div>
            {
                !hideReasons &&
                <Row style={{ paddingBottom: '10px' }}>
                    <Col span={24}>
                            <Select
                                style={{ width: '100%' }}
                                placeholder="Select a Reason"
                                onChange={(value) => {
                                    const selected = reasons.find(r => r.id === value);
                                    setNoteReason(selected);
                                }}
                                value={noteReason?.id}
                                allowClear
                            >
                                {reasons.map(item => (
                                    <Option key={item.id} value={item.id}>{item.name}</Option>
                                ))}
                            </Select>


                    </Col>
                </Row>
            }
            <Row>
                <Col span={24}>
                    <TextArea
                        rows={4}
                        value={noteText}
                        onChange={(e) => setNoteText(e?.target?.value)}
                        placeholder="Note Description"
                    />
                </Col>

            </Row>
        </div>
    );
});
export default AddNote;




